var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.isReadOnly
        ? _c("div", { staticClass: "mb-3", class: _vm.addVariant }, [
            _c("div", { staticClass: "mb-3" }, [
              _vm.icon
                ? _c("em", {
                    staticClass: "fas text-green mr-1",
                    class: _vm.icon
                  })
                : _vm._e(),
              _c("span", { staticClass: "data-name" }, [
                _vm._v(_vm._s(_vm.label))
              ])
            ]),
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c(
                "div",
                {
                  class: {
                    "w-90": !_vm.isAutoSelect,
                    "w-100": _vm.isAutoSelect
                  }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { class: [_vm.isOtherSelected ? "col-6" : "col-12"] },
                      [
                        _vm.isDropDown
                          ? _c("custom-drop-down", {
                              attrs: {
                                id: "options",
                                clearable: true,
                                fieldkey: "id",
                                fieldname: "name",
                                options: _vm.options,
                                placeholder: "Seleccione"
                              },
                              on: { input: _vm.onSelect },
                              model: {
                                value: _vm.innerModel,
                                callback: function($$v) {
                                  _vm.innerModel = $$v
                                },
                                expression: "innerModel"
                              }
                            })
                          : _c("custom-input", {
                              attrs: {
                                label: _vm.label,
                                placeholder: _vm.placeholder
                              },
                              on: {
                                keypress: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  $event.preventDefault()
                                  return _vm.save.apply(null, arguments)
                                }
                              },
                              model: {
                                value: _vm.innerModel,
                                callback: function($$v) {
                                  _vm.innerModel = $$v
                                },
                                expression: "innerModel"
                              }
                            })
                      ],
                      1
                    ),
                    _vm.isOtherSelected
                      ? _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("custom-auto-complete", {
                              staticClass: "search-autocomplete",
                              attrs: {
                                "debounce-time":
                                  _vm.searchSettings?.debounceTime || 2000,
                                "display-text-name":
                                  _vm.searchSettings?.displayProp || "name",
                                "get-result-value":
                                  _vm.searchSettings.resultMap,
                                placeholder:
                                  _vm.searchSettings?.placeholder || "Buscar",
                                search: _vm.search
                              },
                              on: { submit: _vm.searchSubmit },
                              model: {
                                value: _vm.searchSettings.term,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchSettings, "term", $$v)
                                },
                                expression: "searchSettings.term"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]
              ),
              !_vm.isAutoSelect
                ? _c(
                    "div",
                    {
                      staticClass: "w-10 d-flex justify-content-end",
                      class: { "": !_vm.icon }
                    },
                    [
                      _c("action-button", {
                        attrs: {
                          disabled: !_vm.innerModel,
                          i: "fas fa-save",
                          text: "Añadir",
                          variant: "success w-100 ml-2"
                        },
                        on: { click: _vm.save }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm.separator
        ? _c("custom-separator", { attrs: { text: _vm.separator } })
        : _vm._e(),
      !_vm.model.length
        ? _c("custom-result-not-found", {
            staticClass: "my-3",
            attrs: { text: "No hay información disponible." }
          })
        : _vm._e(),
      _c(
        "draggable",
        {
          attrs: {
            disabled: _vm.isReadOnly || !_vm.draggable,
            handle: ".drag-handle",
            list: _vm.model
          },
          on: { end: _vm.onDragEnd }
        },
        _vm._l(_vm.list, function(item, index) {
          return _c(
            "div",
            {
              key: item.id || index,
              staticClass: "rounded p-3 bg-gray my-3",
              class: { "drag-handle": _vm.draggable }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between"
                },
                [
                  _c("div", { staticClass: "d-flex align-items-center" }, [
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "d-inline rounded",
                          class: _vm.draggable
                            ? "indicator-alt"
                            : "indicator bg-success"
                        },
                        [_vm._v(" " + _vm._s(index + 1) + " ")]
                      ),
                      !_vm.isReadOnly && _vm.draggable
                        ? _c("i", {
                            staticClass:
                              "fas fa-grip-vertical m-2 cursor-move drag-handle-icon",
                            attrs: { title: "Arrastrar" }
                          })
                        : _vm._e(),
                      _c("div", { staticClass: "d-inline ml-2" }, [
                        _vm._v(_vm._s(_vm._f("empty")(item?.name ?? item)))
                      ])
                    ])
                  ]),
                  !_vm.isReadOnly
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center justify-content-between"
                          },
                          [
                            _vm.hasChip
                              ? _c(
                                  "Chip",
                                  {
                                    staticClass: "mr-2",
                                    attrs: {
                                      color:
                                        index === 0 ? "#D2F7ED" : "#FFEBEB",
                                      "text-color":
                                        index === 0 ? "#2DB782" : "#FF5B5C"
                                    }
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          index === 0
                                            ? "Primario"
                                            : "Secundario"
                                        )
                                      }
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _c("i", {
                              staticClass:
                                "far fa-times-circle text-danger pointer",
                              on: {
                                click: function($event) {
                                  return _vm.remove(index)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ]
              )
            ]
          )
        }),
        0
      ),
      _vm.showMore
        ? _c("div", { staticClass: "row mx-1" }, [
            _c(
              "div",
              { staticClass: "col text-center" },
              [
                _c(
                  "action-button",
                  {
                    attrs: {
                      i: "far fa-chevron-circle-down",
                      variant:
                        "outline-success custom-view-more actionButton rounded-pill"
                    },
                    on: { click: _vm.handlerMore }
                  },
                  [_vm._v(" Ver más ")]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }